<template>
  <div class="w-full relative" id="scrollf">
    <img
      src="../../../assets/images/15.png"
      alt="bg"
      class="w-full cvr-img-ht mob-hidden"
    />
    <img
      src="../../../assets/images/12.png"
      alt="bg"
      class="w-full cvr-img-ht web-hidden"
    />
    <!-- <p class="text-black covertext absolute">Partner With Us</p> -->
    <div class="text-black covertextall absolute lg:w-1/2 md:w-full w-full">
      <h2
        class="text-black font-semibold fsize45 md-fsize36 sm-fsize20px lg:mb-4 md:mb-4 mb-4"
      >
        <!-- Care Professionals Registration -->
        Welcome to Caregiver Saathi
      </h2>
      <p class="text-black lg:text-lg md:text-lg text-sm">
        <!-- This is a registration form for those looking for opportunities as
        Non-Medical Home Care Professionals with Caregiver Saathi. -->
        We're here to support you and your loved ones. Please fill out the form
        below to let us know how we can assist you. Whether it's through
        educational resources, practical tools, access to caring community,
        support groups, professional home-care services, or corporate programs,
        we're committed to providing the help you need.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
